/* eslint-disable no-use-before-define */
import React from 'react'
import { useOrderTicket } from '../use-order-ticket.js'
import { fmt, Flyout, } from '../../twd'


const ExecutionTypeTooltip = `
    A Fill or Kill order is an order that is either immediately executed, or rejected if it cannot be filled at the specified price.
    Occasionally, E*TRADE will find a better price than what was originally quoted, and will execute the order at the improved price.
    These improved prices are displayed in your order status. A Subject bond order is an order whose both price and availability
    are subject to change after order entry. All secondary market prices you see in search results are external dealer prices.
    No markup is added to these prices by E*TRADE
`

export const ExecutionType = () => {
    const { action, orderInfo, hasOrderInfo, hasBondInfo, executionType_, isTreasuryAuction } = useOrderTicket()
    const isRFQ = action==='W' || action==='F'
    const et = orderInfo.executionType || executionType_
    const txt = !hasOrderInfo || !hasBondInfo ? fmt.empty()
        : isRFQ || isTreasuryAuction ? 'Subject'
        : orderInfo.primary === 'Y' ? 'Firm'
        : et === 'Firm' ? 'Firm (Fill or Kill)'
        : et === 'Limit' ? 'Limit (Fill or Kill)'
        : 'Fill or Kill'

    return <React.Fragment>
        <div className="from-group" style={{paddingLeft:'0px', paddingRight:'0px'}}>
            <div><Flyout
                label="Execution Type"
                html={ExecutionTypeTooltip}
            /></div>
            <div className="input-group  vertical-offset-xxs" >
                <label className="label text-bold">{txt}</label>
            </div>
        </div>
    </React.Fragment>
}
